<template>
    <div class="payment-methods">
        <h1 class="title">Métodos de Pago</h1>
        <div class="payment-grid">
            <div v-for="(method, index) in paymentMethods" :key="index" class="payment-item">
                <img :src="require(`@/assets/imagenes/${method.icon}`)" :alt="method.name" class="payment-icon" />
                <h2>{{ method.name }}</h2>
                <p>{{ method.description }}</p>
            </div>
        </div>
        <div class="button-container">
            <router-link to="/" class="back-button">
                <span class="button-icon">🏠</span>
                Volver a la página principal
            </router-link>
        </div>
        <footer-component />
    </div>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue';

export default {
    name: 'PaymentMethods',
    components: {
        FooterComponent,
    },
    data() {
        return {
            paymentMethods: [
                /*
                {
                    name: 'Tarjeta de Crédito/Débito',
                    icon: 'atm-card.png',
                    description: 'Aceptamos Visa, MasterCard, American Express y Discover.',
                },
                {
                    name: 'Transferencia Bancaria',
                    icon: 'transfer.png',
                    description: 'Realiza una transferencia directa a nuestra cuenta bancaria.',
                },*/
                {
                    name: 'Binance',
                    icon: 'binance.png',
                    description: 'Paga de forma segura usando tu cuenta de Binance.',
                },
            ],
        };
    },
};
</script>

<style scoped>
.payment-methods {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
    background-color: var(--color-background);
    color: var(--color-text);
}

.title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 2rem;
    color: var(--color-title);
}

.payment-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 4rem;
}

.payment-item {
    background-color: var(--color-background-light);
    border-radius: 15px;
    padding: 2rem;
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border: 2px solid var(--color-accent);
    box-shadow: 0 0 15px rgba(255, 20, 147, 0.3);
}

.payment-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(255, 20, 147, 0.4);
}

.payment-icon {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin-bottom: 1rem;
}

.payment-item h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: var(--color-text);
}

.payment-item p {
    font-size: 1rem;
    color: var(--color-text-muted);
}

.button-container {
    display: flex;
    justify-content: center;
    margin: 3rem 0;
}

.back-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1.5rem;
    background-color: var(--color-accent);
    color: var(--color-text);
    text-decoration: none;
    border-radius: 25px;
    font-size: 1rem;
    font-weight: bold;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.back-button:hover {
    background-color: var(--color-accent-hover);
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.button-icon {
    font-size: 1.2rem;
    margin-right: 0.5rem;
}
</style>
